import { colors } from './colors.theme'

export const breadcrumbsTheme = {
  li: {
    '& a,& p': {
      fontSize: 14,
      fontWeight: 400,
      color: colors.white,
    },
    '& p': {
      fontWeight: 400,
    },
    '& a': {
      cursor: 'pointer',
    },
  },
  separator: {
    marginLeft: '5px',
    marginRight: '5px',
  },
}
